[...document.querySelectorAll(".action-print")].forEach((element) => {
  element.addEventListener("click", () => window.print());
});
